import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './routes/index.js';
import { listenToAuthChanges } from './auth/session.js';
import { initI18n } from './i18n/index.js';
import './styles.css';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('No se ha encontrado el contenedor #root en el documento');
}

// El idioma arranca con lo que prefiera el navegador; en cuanto haya sesión, manda el del perfil.
await initI18n();

// Una sola vez, antes de pintar. Sin esta llamada el estado se queda en «cargando» para siempre
// y la vuelta de Google no llega a ninguna parte.
listenToAuthChanges();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
